import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import Chip from "@mui/material/Chip";
import Snackbar from "@mui/material/Snackbar";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
} from ".././PopupDays.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const display = (day, user, name, id, price, profile) => {
  const date = day.toLocaleDateString();
  day = day.getDay();
  if (day === 0) {
    return (
      <Sunday
        date={date}
        user={user}
        name={name}
        id={id}
        price={price}
        profile={profile}
      />
    );
  } else if (day === 1) {
    return <Monday date={date} />;
  } else if (day === 2) {
    return <Tuesday date={date} />;
  } else if (day === 3) {
    return <Wednesday date={date} />;
  } else if (day === 4) {
    return <Thursday date={date} />;
  } else if (day === 5) {
    return <Friday date={date} />;
  } else {
    return <Saturday date={date} />;
  }
};

const Card = (user, name, desg, price, logo, profile, id, setShareUrl) => {
  const navigate = useNavigate();

  // Choose Slot
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [date, setDate] = useState(new Date());

  // Bookmarked?
  const [isBookmarked, setIsBookmarked] = useState(false);
  const Bookmark = () => {
    if (isBookmarked) {
      console.log("Bookmark Added!!!");
      console.log(`Name: ${name}, Desg: ${desg}, Id: ${id}`);
    } else {
      console.log("Bookmark Removed");
    }
  };
  useEffect(() => {
    Bookmark();
  }, [isBookmarked]);

  const [openBookmark, setOpenBookmark] = useState(false);
  const [msg, setMsg] = useState("");
  const handleBookmarkClick = () => {
    setOpenBookmark(true);
  };

  const handleBookmarkClose = () => {
    setOpenBookmark(false);
  };
  return (
    <>
      <div className="grid grid-cols-5 my-2 py-2 border rounded shadow-lg box-shadow-cust">
        <div className="w-full px-2 col-span-4 border-r">
          <div className="flex justify-between w-full">
            <div className="flex gap-2">
              <div className="h-14 w-14 p-1 rounded-md" id="int-logo">
                <img
                  src={require("../../../images/amazon.png")}
                  alt="logo"
                  className="h-full w-full"
                />
              </div>
              <div>
                <Typography
                  variant="h5"
                  component="h5"
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  John Doe
                </Typography>
                <p>SDE III, Postman, India</p>
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                size="large"
                variant="outlined"
                sx={{ padding: "6px", minWidth: "auto" }}
                onClick={() => {
                  setIsBookmarked(!isBookmarked);
                  if (isBookmarked) {
                    console.log(isBookmarked);
                    setMsg("Bookmark Removed");
                  } else {
                    console.log(isBookmarked);
                    setMsg("Bookmark Added");
                  }
                  handleBookmarkClick();
                }}
              >
                {isBookmarked ? (
                  <BookmarkAddedIcon size="large" />
                ) : (
                  // <i className="fa-solid fa-trash-can"></i>
                  <BookmarkBorderIcon size="large" />
                  // <i className="fa-solid fa-bookmark"></i>
                )}
              </Button>
              <Snackbar
                open={openBookmark}
                onClose={handleBookmarkClose}
                message={msg}
                key="bottom left"
              />
              <Button
                size="large"
                variant="outlined"
                color="success"
                sx={{ padding: "6px", minWidth: "auto", fontSize: "24px" }}
                onClick={() => {
                  document
                    .getElementById("share-cont")
                    .classList.remove("hide");
                  setShareUrl("www.twitter.co.in");
                }}
              >
                <i className="fa-solid fa-share"></i>
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-4 justify-between text-center my-1 gap-x-4">
            <div className="mx-2 col-span-2">
              <p className="text-base text-gray-400">Profile/Profiles</p>
              {/* <p className="detail-body">{profile}</p> */}
              <div className="text-lg flex flex-wrap gap-1">
                <Chip
                  label="Data Science"
                  color="info"
                  sx={{ fontWeight: "medium" }}
                />
                <Chip label="Banking and Finance" variant="outlined" />
                {/* <Chip label="Banking and Finance" variant="outlined" /> */}
              </div>
            </div>
            <div className="mx-2">
              <p className="text-base text-gray-400">Duration</p>
              <p className="text-lg">30 Min</p>
            </div>
            <div className="mx-2">
              <p className="text-base text-gray-400">Price</p>
              <p className="text-lg">{price}</p>
            </div>
          </div>
          <div className="flex justify-center">
            <Button
              style={{ marginTop: "10px", textTransform: "none" }}
              variant="contained"
              onClick={handleOpen}
            >
              Choose a Slot
            </Button>
          </div>
        </div>
        <div
          className="cols-span-1 px-2 h-full flex items-center justify-center"
          style={{ flexDirection: "column" }}
        >
          <img
            src={require("../../../images/photo.png")}
            alt="Profile"
            className="block rounded-full w-11/12 p-1 border-2 border-gray-400"
          />
          <Button
            color="secondary"
            sx={{
              fontSize: "12px",
              padding: "4px",
              borderRadius: "4px",
              margin: "8px 0px",
            }}
            onClick={() => {
              navigate("/std-int");
            }}
          >
            View Profile
          </Button>
        </div>
      </div>
    </>
  );
};

export default Card;
